import { ServiceProvider } from "Service";
import { Page } from "./Page";
import CancellationToken from "cancellationtoken";

export class MainPage extends Page {
    private view: kendo.View;

    constructor(serviceProvider: ServiceProvider) {
        super(serviceProvider);
    }

    async render(layout: kendo.Layout, cancellationToken: CancellationToken): Promise<void> {
        await this.initialize("main");

        if (cancellationToken.isCancelled) {
            return;
        }

        await super.render(layout, cancellationToken);

        if (cancellationToken.isCancelled) {
            return;
        }
        
        this.view = new kendo.View(
            `<div class="dms-mapping-wrapper">
                <div data-bind="html: getTextBlockpageDescription" class="dms-textblock mt-1"></div>
            </div>`,
            {
                model: this.viewModel,
                evalTemplate: true,
                wrap: false,
                hide: () => {},
            }
        );

        layout.showIn(".dms-content-container", this.view);
    }

    dispose(): void {
        super.dispose();

        if (this.view) {
            this.view.destroy();
        }
    }
}
